// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_gm-1";
export var rowFirst = "_gm-3";
export var rowLast = "_gm-5";
export var rowMiddle = "_gm-4";
export var ticketListScroll = "_gm-2";
export var ticketStack = "_gm-0";